module.exports = __webpack_public_path__ + "media/images/sluzby-f98a23e3a37e5be09e30d79cb35aca9d.png";